import { onDeactivated, ref } from 'vue';

export const useKeepAliveDeactivateAwareKey = () => {
  const key = ref(Math.random());

  onDeactivated(() => {
    // Reset key when the component is deactivated to ensure it disappears between route changes
    key.value = Math.random();
  });

  return {
    key,
  };
};
